import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Link, useNavigate } from "react-router-dom";
import { ArrowRight, Plus, Compass } from "@phosphor-icons/react";

export default function Construir() {
  const [templates, setTemplates] = useState([]);
  const [playbooks, setPlaybooks] = useState([]);
  const [loading, setLoading] = useState(true);
  const nav = useNavigate();

  useEffect(() => {
    Promise.all([api.get("/playbooks/templates"), api.get("/playbooks")])
      .then(([t, p]) => { setTemplates(t.data.templates || []); setPlaybooks(p.data.playbooks || []); })
      .catch(() => toast.error("No se pudo cargar el catálogo"))
      .finally(() => setLoading(false));
  }, []);

  const iniciar = async (name) => {
    try {
      const { data } = await api.post("/playbooks/from-template", { name });
      toast.success(`Ruta "${name}" iniciada`);
      nav(`/playbooks/${data.id}`);
    } catch { toast.error("No se pudo iniciar el playbook"); }
  };

  return (
    <div data-testid="page-construir">
      <header className="mb-8">
        <div className="label-mono text-muted-foreground">Construir Mi Negocio</div>
        <h1 className="display text-5xl md:text-6xl mt-1">De la idea al lanzamiento</h1>
        <p className="mt-3 max-w-2xl text-sm text-muted-foreground">
          Elige un playbook para empezar. Cada uno te lleva paso a paso con etapas, hitos y tareas hasta la primera venta.
        </p>
      </header>

      <section className="mb-10">
        <div className="label-mono text-muted-foreground mb-3">Elige tu camino</div>
        {loading && <div className="text-sm text-muted-foreground">Cargando…</div>}
        <div className="grid md:grid-cols-2 gap-4">
          {templates.map((t) => (
            <div key={t.name} className="brut-card" data-testid={`plantilla-${t.name.replace(/\s+/g, "-").toLowerCase()}`}>
              <div className="flex items-start justify-between gap-4">
                <div>
                  <div className="label-mono text-muted-foreground">{t.category}</div>
                  <div className="display text-2xl mt-1">{t.name}</div>
                  <p className="text-sm text-muted-foreground mt-2">{t.description}</p>
                </div>
                <Compass size={22} weight="bold" />
              </div>
              <div className="mt-4 flex items-center justify-between">
                <div className="label-mono text-muted-foreground">{t.stages_count} etapas</div>
                <button onClick={() => iniciar(t.name)} className="btn-primary flex items-center gap-2" data-testid={`btn-iniciar-${t.name.replace(/\s+/g, "-").toLowerCase()}`}>
                  <Plus size={14} weight="bold" /> Iniciar
                </button>
              </div>
            </div>
          ))}
        </div>
      </section>

      {playbooks.length > 0 && (
        <section>
          <div className="label-mono text-muted-foreground mb-3">Ya iniciados</div>
          <div className="grid md:grid-cols-2 gap-4">
            {playbooks.map((p) => (
              <Link key={p.id} to={`/playbooks/${p.id}`} className="brut-card hover:bg-muted transition-colors flex items-center justify-between" data-testid={`iniciado-${p.id}`}>
                <div>
                  <div className="display text-xl">{p.name}</div>
                  <div className="text-xs text-muted-foreground mt-1">{p.stages.length} etapas</div>
                </div>
                <ArrowRight size={18} weight="bold" />
              </Link>
            ))}
          </div>
        </section>
      )}
    </div>
  );
}
